module.exports = "https://trybtryb-legacy.web.app/img/square-transparent-desktop.6fda7580.svg";